import React from 'react'
import { Button } from 'reactstrap'

interface LinkButtonProps {
    children: React.ReactNode
    onClick?: () => void
}

/**
 * This component allows to render a button used for links
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const LinkButton: React.FC<LinkButtonProps> = ({ children, onClick }) => {
    return (
        <Button color="link" size="xs" onClick={onClick}>
            {children}
        </Button>
    )
}

export default LinkButton
